var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 387936239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.7025 1.18969C11.7763 1.06916 11.8191 0.9292 11.8191 0.777573C11.8191 0.349908 11.4692 0 11.0415 0H8.04788C7.62022 0 7.27031 0.349908 7.27031 0.777573C7.27031 0.921424 7.30919 1.05361 7.37917 1.17025C5.65296 1.56292 4.06671 2.4338 2.78371 3.7168C0.987518 5.51299 0 7.89626 0 10.435C0 12.9738 0.987518 15.361 2.78371 17.1572C4.57602 18.9495 6.95928 19.9448 9.49806 19.9448C12.0368 19.9448 14.4201 18.9495 16.2163 17.1572C18.0125 15.361 19 12.9699 19 10.435C19 7.89626 18.0125 5.51299 16.2163 3.7168C14.9527 2.45324 13.3976 1.59014 11.7025 1.18969ZM15.116 16.053C13.6153 17.5537 11.6208 18.3818 9.49806 18.3818C5.11643 18.3818 1.55126 14.8167 1.55126 10.435C1.55126 8.31226 2.37937 6.31778 3.88009 4.81707C5.38081 3.31246 7.37528 2.48823 9.49806 2.48823C13.8797 2.48823 17.4449 6.05341 17.4449 10.435C17.4449 12.5539 16.6167 14.5523 15.116 16.053Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.4056 10.9247H10.0317V6.62856C10.0317 6.20478 9.70124 5.84321 9.28135 5.83155C8.83813 5.816 8.47656 6.16979 8.47656 6.60912V11.8189C8.47656 12.1843 8.77204 12.4798 9.1375 12.4798H14.425C14.8643 12.4798 15.2181 12.1182 15.2026 11.675C15.187 11.2551 14.8254 10.9247 14.4056 10.9247Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.2743b82a054e08deb8ce470e44ec1c5c.svg";
export { ForwardRef as ReactComponent };